import type AnalyticsClient from '@atlassiansox/analytics-web-client/client';
import type {
	AnalyticsEvent,
	AnalyticsWebClient,
	InitAttrs,
	OriginTracingHandlerMapping,
	UIViewedAttributes,
	UnknownEvent,
} from '@jira/platform__observability-product-analytics-web-client-types';

export const mockAnalyticsWebClient: AnalyticsWebClient = {
	init: (_attrs: InitAttrs) => false,
	sendEvent: (_event: AnalyticsEvent | UnknownEvent) => undefined,
	// oxlint-disable-next-line typescript/consistent-type-assertions
	getInstance: () => mockAnalyticsWebClient as unknown as AnalyticsClient,
	setSubProduct: (_subproduct: string) => undefined,
	setEmbeddedProduct: (_embeddedProduct: string) => undefined,
	clearEmbeddedProduct: () => undefined,
	stopApdexEvent: () => undefined,
	setOriginTracingHandlers: (_originParamHandlerMapping: OriginTracingHandlerMapping) => undefined,
	setUIViewedAttributes: (_attributes: UIViewedAttributes) => undefined,
	removeUIViewedAttribute: (_key: keyof UIViewedAttributes) => undefined,
	clearUIViewedAttributes: () => undefined,
	isInitialized: () => false,
	setUpdateAmplitudeSRClient: () => undefined,
	setAmplitudeSRAttributesInjector: () => undefined,
};
